export default {
  'home.announcement': 'Independent informational resource — not affiliated with or endorsed by USFans.',
  'home.heroTitle': 'The Smarter Way to Explore the USFans Spreadsheet',
  'home.heroSub': 'Discover useful finds, compare categories, understand QC, check shipping details and learn how to research products before you order.',
  'home.primaryCta': 'USFans Spreadsheet',
  'home.secondaryCta': 'Read the Guide',
  'home.trustLine': 'Independent Research · Updated Guides · Safety-Focused Information',

  'home.categoriesTitle': 'Explore USFans Spreadsheet Categories',
  'home.categoriesSub': 'Jump straight to a category and browse the latest finds on the main site.',
  'home.categoryDropdownLabel': 'Choose a category',

  'home.whatTitle': 'What Is the USFans Spreadsheet?',
  'home.whatP1': 'The USFans Spreadsheet is a shared research resource that many people use to organize product links, categories, seller notes, QC details and buying references in one place. Instead of scrolling through scattered pages, users rely on the spreadsheet to browse items more efficiently and to compare options before deciding.',
  'home.whatP2': 'It is important to be clear about what the spreadsheet is not. It is not an official marketplace, and it is not run by a brand itself. Think of it as a community-built directory and note-taking system: the value comes from how the information is collected, organized and kept up to date, not from a promise made by a single seller.',
  'home.whatP3': 'A typical spreadsheet is organized by category — shoes, hoodies, t-shirts, jackets, pants, jerseys, accessories and more — with columns for product names, links, sizes, seller references, QC notes and shipping details. Some versions also include warehouse information and tips on how to read QC photos.',
  'home.whatNotice': 'Independent Website Notice',
  'home.whatNoticeText': 'This website is an independent informational resource. It is not officially affiliated with or endorsed by USFans unless explicitly stated.',

  'home.benefitsTitle': 'Why Start With a Spreadsheet?',
  'home.benefitsSub': 'A well-organized spreadsheet turns scattered research into a clear, repeatable process.',
  'home.benefit1Title': 'Discover Faster',
  'home.benefit1Desc': 'Find relevant product resources without browsing scattered pages.',
  'home.benefit2Title': 'Compare Better',
  'home.benefit2Desc': 'Compare categories, product information and research notes side by side.',
  'home.benefit3Title': 'Check QC Carefully',
  'home.benefit3Desc': 'Understand what to look for before international shipping.',
  'home.benefit4Title': 'Research With Confidence',
  'home.benefit4Desc': 'Learn about shipping, warehouse processes, safety and common mistakes.',
  'home.benefitCta': 'Explore the USFans Spreadsheet',

  'home.checklistTitle': 'USFans Spreadsheet Research Checklist',
  'home.checklistSub': 'A quick reference for what to check before you take the next step.',
  'home.checkArea': 'Research Area',
  'home.checkWhat': 'What to Check',
  'home.checkWhy': 'Why It Matters',
  'home.check.r1.area': 'Product',
  'home.check.r1.what': 'Price, seller, category',
  'home.check.r1.why': 'Avoid poor choices',
  'home.check.r2.area': 'QC',
  'home.check.r2.what': 'Photos, details, flaws',
  'home.check.r2.why': 'Catch issues early',
  'home.check.r3.area': 'Warehouse',
  'home.check.r3.what': 'Storage, inspection',
  'home.check.r3.why': 'Understand order status',
  'home.check.r4.area': 'Shipping',
  'home.check.r4.what': 'Weight, volume, route',
  'home.check.r4.why': 'Estimate total cost',
  'home.check.r5.area': 'Seller',
  'home.check.r5.what': 'History, feedback',
  'home.check.r5.why': 'Reduce uncertainty',
  'home.check.r6.area': 'Safety',
  'home.check.r6.what': 'Links, payment, privacy',
  'home.check.r6.why': 'Avoid suspicious activity',

  'home.guidesTitle': 'Research USFans With Confidence',
  'home.guidesSub': 'Start with our guides, then explore the topics that matter to you.',
  'home.guide.review.title': 'USFans Review',
  'home.guide.review.desc': 'Understand the platform, workflow, strengths and potential risks.',
  'home.guide.shipping.title': 'Shipping Cost',
  'home.guide.shipping.desc': 'Learn what can affect international shipping costs.',
  'home.guide.safety.title': 'Safety Guide',
  'home.guide.safety.desc': 'Understand common risks and safer research practices.',
  'home.guide.article.title': 'Complete Beginner Guide',
  'home.guide.article.desc': 'Our original in-depth guide to the USFans Spreadsheet.',

  'home.faqTitle': 'USFans Spreadsheet FAQ',
  'home.faqSub': 'Answers to the questions people ask most.',
  'home.faq.q1': 'What is the USFans Spreadsheet?',
  'home.faq.a1': 'It is a shared research resource used to organize product links, categories, seller notes, QC details and buying references in one place.',
  'home.faq.q2': 'How do I use the USFans Spreadsheet?',
  'home.faq.a2': 'Browse by category, review product and QC notes, compare options, and use the links to continue your research before placing an order.',
  'home.faq.q3': 'Is USFans legit?',
  'home.faq.a3': 'We keep a neutral position. Check seller history, read feedback and verify links and payment pages before trusting any claim.',
  'home.faq.q4': 'Is USFans safe?',
  'home.faq.a4': 'Safety depends on how carefully you research. Avoid sharing passwords or sensitive details and verify every link before clicking.',
  'home.faq.q5': 'How much does USFans shipping cost?',
  'home.faq.a5': 'Costs vary by weight, volume, route and destination. Use estimates rather than fixed prices and confirm before ordering.',
  'home.faq.q6': 'Does USFans have coupons?',
  'home.faq.a6': 'Offers change frequently. Always check the current official offer before using any coupon or discount code.',
  'home.faq.q7': 'What is the USFans warehouse?',
  'home.faq.a7': 'It refers to storage and inspection services that may be used to hold, check and consolidate items before shipping.',
  'home.faq.q8': 'How does USFans QC work?',
  'home.faq.a8': 'QC photos and notes help you spot flaws, wrong sizes or damaged items before they are shipped internationally.',

  'home.finalTitle': 'Ready to Explore the USFans Spreadsheet?',
  'home.finalText': 'Use our guides, comparisons and research resources to make the process easier, understand the risks and find the information you need before taking the next step.',
  'home.finalCta': 'Buy It Now',
  'home.finalSecondary': 'USFans Spreadsheet',

  'home.articlesTitle': 'Latest USFans Guides & Articles',
  'home.articlesSub': 'In-depth, original articles to help you research smarter.',
};